import styled from "styled-components";

export const AmountCard = styled.div`
  color: #101e8e;
  background: #edf4f6;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  padding: 1rem;
  width: 60%;
`;
